import "../../Components/Page/Page.css";
import "../../Pages/Investment/Investment.css";
import graph1 from "../../Images/Investor/AvrgEfficiency.png";
import graph2 from "../../Images/Investor/LogOfWeight.png";

import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";

const ElfPower: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="The Power of Elf-Tech™ Geometry" />
      <SubSection>
        <ImageComp imageSource={graph1} width={"Clamp(18rem, 30vw, 36rem)"} />
        <ImageComp imageSource={graph2} width={"Clamp(18rem, 30vw, 36rem)"} />
      </SubSection>
      <SubSection isSplit={false}>
        <div className="inv-items">
          <div className="inv-item">
            <h4 className="inv-item-title">Consistent performance advantages</h4>
            <p className="inv-item-body">
              Driven by our new shapes, computer modeling shows ELF-Tech designs consistently demonstrate:
            </p>
            <ul>
              <li>Higher fuel efficiency</li>
              <li>Reduced emissions</li>
              <li>Higher power to weight ratio</li>
            </ul>
          </div>
        </div>
      </SubSection>
    </div>
  );
};

export default ElfPower;
